import React, { useReducer, useEffect } from "react";
import { getIn } from "immutable";
import { FormControl, Input } from "components";

const CustomText = ({
	context,
	className = "",
	label,
	path,
	min = 0.5,
	max = 2,
	hasColor,
	hasNumber = true,
	onFocus,
	onBlur,
	withSwitch,
	labelColor,
	marginBottom,
	info,
	text
}) => {
	const { state, setItem, validationErrors } = context;
	const textPAth = path + ".text";
	const fontSizePAth = path + ".font_size";
	const colorPath = path + ".color";
	const withNumber = hasNumber
		? {
				value: getIn(state, fontSizePAth.split(".")),
				onChange: (e) => {
					// console.log(e.target.value, JSON.parse(e.target.value));
					setItem(fontSizePAth, JSON.parse(e.target.value));
				},
				icon: { char: "EM" },
				min,
				max,
				step: 0.1
		  }
		: undefined;
	const withColor = hasColor
		? {
				value: getIn(state, colorPath.split(".")),
				onChange: (value) => setItem(colorPath, value)
		  }
		: false;

	return (
		<FormControl
			label={label}
			info={info}
			className={className}
			error={validationErrors[textPAth] || validationErrors[fontSizePAth]}
			labelColor={labelColor}
			withSwitch={withSwitch}
			marginBottom={marginBottom}
		>
			<Input
				onFocus={onFocus}
				onBlur={onBlur}
				type="text"
				BindToContext={[context, textPAth]}
				withColor={withColor}
				withNumber={withNumber}
			/>
		</FormControl>
	);
};

export default CustomText;
